// @flow

import type {Tag as TagType, RenderNode} from '@markdoc/markdoc';

// %checks is documented here: https://flow.org/en/docs/types/functions/#toc-predicate-functions
export function isMarkdocAstTag(
  tag: RenderNode | Array<RenderNode>,
): boolean %checks {
  return tag != null && typeof tag === 'object' && !Array.isArray(tag);
}

// This is a stub helper class to help transition an older version of Markdoc to the present APIs
export class Tag {
  constructor(
    name: $PropertyType<TagType, 'name'>,
    attributes?: $PropertyType<TagType, 'attributes'> = {},
    children?: $PropertyType<TagType, 'children'> = [],
  ): TagType {
    return {
      name,
      attributes,
      children,
    };
  }
}
